<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card v-if="dialog">
          <v-card-title class="primary white--text title">
              {{'Connector'|translate}}
          </v-card-title>
          <v-card-text>
              <v-text-field :label="'Name'|translate" v-model="name"></v-text-field>
              <v-combobox
                      :items="connectorTypes"
                      :label="'Type'|translate"
                      v-model="type"
              ></v-combobox>
              <editor v-model="config" @init="editorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline class="mr-2" @click="dialog=false">{{'Cancel'|translate}}</v-btn>
              <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!$can('update', 'Connector')">{{'Save'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

  import {putConnector} from '../helper'
  import editor from 'vue2-ace-editor'
  export default {
      components: {editor},
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
            let newitem=JSON.parse(JSON.stringify(item))
          this.connector_id = newitem['connector_id']
          this.name= newitem['name']
          this.type = newitem['type']
          this.config = newitem['config']&&newitem['config']!=="" ? JSON.stringify(newitem['config']) : newitem['config']

        }
      },
      value () {
        if (this.dialog !=this.value){
          this.dialog=this.value
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    data () {
        return {
            dialog: false,
            connector_id: null,
            name: null,
            type: null,
            config: '',
            connectorTypes:['bacnet', 'haystack', 'desigo', 'desigo_pqm', 'jedi', 'hko', 'mqtt', 'sg_weather', 'dummy', 'ftp', 'hko_solar', 'cloud_coverage', 'solar_irradiance', 'opc', 'modbus', 'solar_altitude', 'hko_aa', 'writable', 'hko_forecast', 'iaqiot', 'mega_http', 'holiday', 'carnot', 'notification', 'metar_weather', 'anacle', 'calendar'].sort()

      }
    },
    methods: {
        editorInit: function () {
            require('brace/ext/language_tools')
            require('brace/mode/json')
            require('brace/theme/twilight')
        },
      initializeVar() {
        this.name= null
        this.config= ''
        this.connector_id = null
        this.type = null
      },
      async addRecord () {
          await putConnector(
              {
                  'connector_id': this.connector_id,
                  'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                  'name': this.name,
                  'type': this.type,
                  'config': this.config&&this.config!=="" ? JSON.parse(this.config) : this.config,
              }
          )
          this.$emit('doreload')
          this.dialog=false
      }
    },
    name: 'ConnectorDialog'
  }
</script>

<style scoped>

</style>
